const HttpBackend = require('i18next-http-backend/cjs');
const LanguageDetector = require('i18next-browser-languagedetector/cjs');

module.exports = {
  i18n: {
    defaultLocale: 'en-US',
    locales: ['en-US', 'de', 'ru', 'tr'],
  },

  backend: {
    loadPath: `${process.env.API_URL}umbraco/api/Dictionary/GetDictionaryEntries?language={{lng}}`,
    overrideMimeType: true,
    expirationTime: process.env.NODE_ENV === 'development' ? 0 : 60 * 1000, // 1 minute
  },

  detection: {
    order: ['cookie', 'navigator'],
    caches: ['cookie'],
  },

  reloadOnPrerender: process.env.NODE_ENV === 'development',

  ns: ['common'],
  defaultNS: 'common',

  use: [HttpBackend, LanguageDetector],

  debug: false,
  serializeConfig: false,
  fallbackLng: false,
};
